'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLink = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var _classnames;

  var _ref$Tag = _ref.Tag,
      Tag = _ref$Tag === undefined ? 'button' : _ref$Tag,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'button' : _ref$type,
      className = _ref.className,
      size = _ref.size,
      border = _ref.border,
      square = _ref.square,
      color = _ref.color,
      pill = _ref.pill,
      spinner = _ref.spinner,
      block = _ref.block,
      children = _ref.children,
      label = _ref.label,
      props = (0, _objectWithoutProperties3.default)(_ref, ['Tag', 'type', 'className', 'size', 'border', 'square', 'color', 'pill', 'spinner', 'block', 'children', 'label']);
  return _react2.default.createElement(Tag, (0, _extends3.default)({}, props, {
    type: type,
    className: (0, _classnames3.default)(className, (_classnames = {}, (0, _defineProperty3.default)(_classnames, 'button-' + (_constants.sizeAliases[size] || size), size), (0, _defineProperty3.default)(_classnames, 'button-' + color, color && !_constants.indicatorMap[color]), (0, _defineProperty3.default)(_classnames, 'button-block', block), (0, _defineProperty3.default)(_classnames, 'button-border', border), (0, _defineProperty3.default)(_classnames, 'button-pill', pill), (0, _defineProperty3.default)(_classnames, 'button-square', square), (0, _defineProperty3.default)(_classnames, 'spinner', spinner), (0, _defineProperty3.default)(_classnames, color, _constants.indicatorMap[color]), _classnames)) || null,
    children: children || label
  }));
};

var ButtonLink = exports.ButtonLink = function ButtonLink(props) {
  return _react2.default.createElement(Button, (0, _extends3.default)({}, props, { Tag: 'a', className: ['button', props.className], type: null }));
};

exports.default = Button;